import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import AttentionHours from './AttentionHours'
import { Button } from '../../atoms/Button'
import OtherFormAdditionalConfig from './OtherFormAdditionalConfig'
import EditCancelButton from '../../molecules/buttons/EditCancelButton'
import SwitchOtherForm from './SwitchOtherForm'
import ToastAlert from '../../molecules/ToastAlert'
import { defaultHours } from '../../../configs/officeHourConfig'

const OfficeHoursOtherForm = ({ initialValues, onSubmit }) => {
  const [editMode, setEditMode] = useState(false)
  const [editEnabled, setEditEnabled] = useState(initialValues.other_forms_enabled || false)
  const [saveCompleted, setSaveCompleted] = useState(false)
  const [alertText, setAlertText] = useState('Cambios guardados exitosamente.')
  const [alertStatus, setAlertStatus] = useState('success')

  const handleSubmit = async values => {
    try {
      await onSubmit(values)
      setEditMode(false)
      setAlertText(
        initialValues.other_forms_enabled
          ? 'Cambios guardados exitosamente.'
          : 'Se habilitó el horario de atención para formularios exitosamente (excepto Mesa de partes).'
      )
      setAlertStatus('success')
      setSaveCompleted(true)
    } catch (error) {
      setAlertText('Ocurrió un error al guardar los cambios.')
      setAlertStatus('error')
      setSaveCompleted(true)
    }
  }

  const handleEdit = form => {
    if (editMode) {
      handleCancel(form)
    } else {
      setEditMode(true)
    }
  }

  const handleEditEnabled = (value, form) => {
    setEditEnabled(value)
    if (!value) {
      handleSubmit({
        other_forms_enabled: false
      })
    }
    if (value) {
      form.change('other_forms_start_office_hour', defaultHours.start)
      form.change('other_forms_end_office_hour', defaultHours.end)
      form.change('other_forms_additional_config', 'suggested_required')
      setEditMode(true)
    }
  }

  const handleCancel = form => {
    setEditMode(false)
    setEditEnabled(initialValues.other_forms_enabled)
    form.reset()
  }

  return (
    <div className="p-10 bg-neutral-100 rounded-2.5xl">
      <Form
        onSubmit={handleSubmit}
        initialValues={initialValues}
        subscription={{ submitting: true, pristine: true }}
        autoComplete="off"
      >
        {({ handleSubmit, submitting, pristine, form }) => (
          <form onSubmit={handleSubmit}>
            <div className="flex justify-between md:items-center items-start">
              <div>
                <h2 className="text-xl font-bold">Horario de atención de otros formularios</h2>
                <p>Habilita la configuración del horario de atención de tu entidad.</p>
              </div>
              <SwitchOtherForm onEnabled={value => handleEditEnabled(value, form)} />
            </div>
            {editEnabled && (
              <div className="bg-neutral-350 p-8 rounded-xl flex flex-col gap-6 mt-6">
                <div className="flex justify-end">
                  <EditCancelButton onClick={() => handleEdit(form)} editMode={editMode} />
                </div>
                <div className="flex flex-col w-full gap-6">
                  <AttentionHours
                    enabled={editMode}
                    startName="other_forms_start_office_hour"
                    endName="other_forms_end_office_hour"
                    required
                  />
                  <OtherFormAdditionalConfig enabled={editMode} />
                </div>
                {editMode && (
                  <div className="flex flex-col-reverse md:flex-row justify-end gap-4 text-lg">
                    <Button
                      variant="text"
                      size="full"
                      type="button"
                      className="block py-3 md:max-w-56"
                      disabled={submitting || pristine}
                      onClick={() => handleCancel(form)}
                    >
                      Cancelar
                    </Button>
                    <Button
                      size="full"
                      type="submit"
                      className="block py-3 md:max-w-56"
                      disabled={submitting || pristine}
                    >
                      Guardar
                    </Button>
                  </div>
                )}
              </div>
            )}
          </form>
        )}
      </Form>
      <ToastAlert
        alertText={alertText}
        type={alertStatus}
        open={saveCompleted}
        onClose={() => setSaveCompleted(false)}
      />
    </div>
  )
}

export default OfficeHoursOtherForm

OfficeHoursOtherForm.propTypes = {
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired
}
